class FurseraPurchaseAssurance extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.backdrop = this.querySelector('[data-backdrop]');
    this.drawers = new Map(
      Array.from(this.querySelectorAll('[data-drawer]')).map((drawer) => [drawer.dataset.drawer, drawer]),
    );
    this.onKeydown = (event) => { if (event.key === 'Escape') this.close(); };
    this.querySelectorAll('[data-open]').forEach((button) => {
      button.addEventListener('click', () => this.open(button.dataset.open, button));
    });
    this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    this.backdrop?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', this.onKeydown);

    // The product information column creates its own stacking context. Keeping
    // fixed drawers inside it lets the sticky global header render above the
    // backdrop regardless of how large the drawer z-index is. Portal the
    // overlay nodes to <body> so they participate in the page's top-level stack.
    if (this.backdrop) document.body.appendChild(this.backdrop);
    this.drawers.forEach((drawer) => document.body.appendChild(drawer));
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    this.backdrop?.remove();
    this.drawers?.forEach((drawer) => drawer.remove());
  }

  open(name, trigger) {
    const drawer = this.drawers?.get(name);
    if (!drawer) return;
    this.close(false);
    this.activeDrawer = drawer;
    this.lastTrigger = trigger;
    if (this.backdrop) this.backdrop.hidden = false;
    drawer.hidden = false;
    document.body.classList.add('fursera-assurance-open');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.querySelector('[data-close]:last-of-type')?.focus();
  }

  close(restoreFocus = true) {
    if (!this.activeDrawer) return;
    const drawer = this.activeDrawer;
    drawer.classList.remove('is-open');
    this.activeDrawer = null;
    document.body.classList.remove('fursera-assurance-open');
    if (this.backdrop) this.backdrop.hidden = true;
    window.setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 250);
    if (restoreFocus) this.lastTrigger?.focus();
  }
}

if (!customElements.get('fursera-purchase-assurance')) customElements.define('fursera-purchase-assurance', FurseraPurchaseAssurance);
